import React from 'react';

import integration from 'src/lib/api/integration';
import jira from 'src/lib/api/jira';

import ModalContainer from 'src/views/components/ModalContainer';

import RuleForm from './RuleForm';

const initRule = {
  name: '',
  enabled: true,
  config: {
    sync_comments: true,
    services: [],
    projects: [],
    issue_types: [],
  }
};

const onSave = async (rule) => {
  const response = await integration.createRule(rule)
    .catch(e => Promise.reject(['Failed to create Rule', e]));
  await jira.setSidebarVisibility(response.config?.projects, false)
    .catch(e => console.error('Failed to set sidebar visibility on create rule', e));
  return response;
};

const CreateRuleModal = () => {
  return (
    <ModalContainer title="Create new rule">
      <RuleForm
        rule={initRule}
        onSave={onSave}
      />
    </ModalContainer>
  );
};

export default CreateRuleModal;
